import {useSelector} from "react-redux";
import {selectUserProfile} from "state/selectors/app";

export function useRootNode() {
    const {root_node_id: rootNode} = useSelector(s=>selectUserProfile(s));
    return rootNode;
}